import { IApiResponse, IStaticPage } from "../models/Interfaces";
import { BaseService } from "./BaseService";

export class StaticPageService extends BaseService {
  
  public getStaticPages = async (language: string) : Promise<Array<IStaticPage>> => {
    if (this.siteKey && language) {
      const url: string = `/SiteAdmin/GetStaticRoutes/${this.siteKey}/${language}`;
      const res = await this._ajaxService.Get<IApiResponse>(url, true);

      if (res?.StatusCode === 200 && res.ReturnData) {
        return res.ReturnData;
      } else {
        if (res?.StatusCode !== 404) {
          this.EmitDataError(res, "Failed to retrieve static pages");
        }
      }
    }
    return [];
  }

  public saveStaticPage = async (staticpage: IStaticPage) : Promise<IStaticPage | null> => {
    if (this.siteKey && staticpage) {
      const url: string = "/SiteAdmin/SaveStaticRoute";
      const res = await this._ajaxService.Post<IApiResponse>(url, staticpage, true);

      if (res?.StatusCode === 200 && res.ReturnData) {
        return res.ReturnData;
      } else {
        this.EmitDataError(res, "Failed to save static page details");
      }
    }
    return null;
  }

  public deleteStaticPage = async (id: number) : Promise<boolean> => {
    if (this.siteKey && id) {
      const url: string = `/SiteAdmin/DeleteStaticRoute/${this.siteKey}/${id}`;
      const res = await this._ajaxService.Get<IApiResponse>(url, true);

      if (res?.StatusCode === 200) {
        return true;
      } else {
        this.EmitDataError(res, "Failed to remove static page details");
      }
    }
    return false;
  }

  public newStaticPage = (shortcode?: string) : IStaticPage | null => {
    if (this.siteKey) {
      return {
        Id: 0,
        Enabled: true,
        IncludeOnSiteMap: true,
        Language: shortcode ?? "en-gb",
        SiteId: this.siteKey,
        StaticPagePath: "",
        Url: ""
      };
    }
    return null;
  }
}